import React from 'react';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  const handleCTAClick = () => {
    trackAddToCart();
  };
  return <section id="comprar" className="w-full bg-navy py-16 md:py-24 px-4" data-id="element-26">
      <div className="max-w-3xl mx-auto" data-id="element-27">
        <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-12" data-id="element-28">
          Hoy puedes elegir:
        </h2>

        {/* Options */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-29">
          {/* Option A */}
          <div className="bg-navy-light border-2 border-alert rounded-xl p-6" data-id="element-30">
            <h3 className="text-alert font-bold text-lg mb-4" data-id="element-31">
              OPCIÓN A: Seguir igual.
            </h3>
            <div className="border-t border-white/20 my-4" data-id="element-32"></div>
            <p className="text-gray-300" data-id="element-33">Otra noche mirando el techo.</p>
            <p className="text-gray-300" data-id="element-34">Otro día arrastrando el cansancio.</p>
            <p className="text-gray-300" data-id="element-35">El mismo ciclo de siempre.</p>
          </div>

          {/* Option B */}
          <div className="bg-navy-light border-2 border-cta rounded-xl p-6 ring-2 ring-cta/30" data-id="element-36">
            <h3 className="text-cta font-bold text-lg mb-4" data-id="element-37">
              OPCIÓN B: Empezar esta noche.
            </h3>
            <div className="border-t border-white/20 my-4" data-id="element-38"></div>
            <p className="text-white" data-id="element-39">Reset de 7 minutos hoy.</p>
            <p className="text-white" data-id="element-40">Primera señal de seguridad.</p>
            <p className="text-white" data-id="element-41">14 noches. Otro resultado posible.</p>
          </div>
        </div>

        {/* Pricing Summary */}
        <div className="border-2 border-cta bg-navy-light rounded-xl p-8 text-center mb-8 max-w-lg mx-auto" data-id="element-42">
          <div className="space-y-2 text-left mb-6" data-id="element-43">
            <p className="text-white flex justify-between" data-id="element-44">
              <span data-id="element-45">📘 Guía Principal</span>
              <span className="line-through text-gray-500" data-id="element-46">$14.99</span>
            </p>
            <p className="text-white flex justify-between" data-id="element-47">
              <span data-id="element-48">🎁 Workbook 14 Noches</span>
              <span data-id="element-49">
                <span className="line-through text-gray-500" data-id="element-50">$7.99</span>
                <span className="text-cta ml-2" data-id="element-51">GRATIS</span>
              </span>
            </p>
            <p className="text-white flex justify-between" data-id="element-52">
              <span data-id="element-53">🎁 Reset de 7 Minutos</span>
              <span data-id="element-54">
                <span className="line-through text-gray-500" data-id="element-55">$4.99</span>
                <span className="text-cta ml-2" data-id="element-56">GRATIS</span>
              </span>
            </p>
            <p className="text-white flex justify-between" data-id="element-57">
              <span data-id="element-58">🎁 Kit Emergencias SOS 3AM</span>
              <span data-id="element-59">
                <span className="line-through text-gray-500" data-id="element-60">$7.99</span>
                <span className="text-cta ml-2" data-id="element-61">GRATIS</span>
              </span>
            </p>
          </div>

          <div className="border-t border-white/20 my-4" data-id="element-62"></div>

          <p className="text-gray-400 mb-2" data-id="element-63">
            VALOR TOTAL: <span className="line-through" data-id="element-64">$35.96</span>
          </p>
          <p className="text-white text-3xl md:text-4xl font-bold" data-id="element-65">
            PRECIO HOY: $6.39
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="text-center space-y-4" data-id="element-66">
          <a href="https://novadigitalventures.com/cart/42535353811015:1" onClick={handleCTAClick} className="animate-pulse-cta bg-cta text-navy font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-full hover:bg-cta/90 transition-colors w-full md:w-auto inline-block text-center" data-id="element-67">
            Quiero el protocolo completo →
          </a>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-white/80 mt-6" data-id="element-68">
            <span data-id="element-69">⚡ Descarga instantánea</span>
            <span data-id="element-70">📱 Funciona en cualquier dispositivo</span>
            <span data-id="element-71">🔒 Pago 100% seguro</span>
            <span data-id="element-72">🛡️ Garantía 30 días sin preguntas</span>
          </div>
        </div>
      </div>
    </section>;
}